var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenuPersonalIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "guest-icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4791",
    "data-name": "Rectangle 4791",
    width: 24,
    height: 24,
    fill: "rgba(255,255,255,0)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_15255",
    "data-name": "Group 15255",
    transform: "translate(4.255 2.534)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15256",
    "data-name": "Group 15256"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34086",
    "data-name": "Path 34086",
    d: "M267.245,464.721a6.024,6.024,0,0,0-6.024,6.024v1.721a.861.861,0,0,1-1.721,0v-1.721a7.745,7.745,0,0,1,15.49,0v1.721a.861.861,0,1,1-1.721,0v-1.721A6.024,6.024,0,0,0,267.245,464.721Z",
    transform: "translate(-259.5 -454.395)",
    fill: "#6b6b95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34087",
    "data-name": "Path 34087",
    d: "M267.663,461.605a3.442,3.442,0,1,0-3.442-3.442A3.442,3.442,0,0,0,267.663,461.605Zm0,1.721a5.163,5.163,0,1,0-5.163-5.163A5.163,5.163,0,0,0,267.663,463.326Z",
    transform: "translate(-259.918 -453)",
    fill: "#6b6b95",
    fillRule: "evenodd"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuPersonalIcon);
export default __webpack_public_path__ + "static/media/menuPersonalIcon.e60fd6532727777ca92e93c877b9284f.svg";
export { ForwardRef as ReactComponent };